import { render, staticRenderFns } from "./addComponent.vue?vue&type=template&id=8834d7d8&scoped=true&"
import script from "./addComponent.vue?vue&type=script&lang=js&"
export * from "./addComponent.vue?vue&type=script&lang=js&"
import style0 from "./addComponent.vue?vue&type=style&index=0&id=8834d7d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8834d7d8",
  null
  
)

export default component.exports